export default "__VITE_ASSET__6b4c57bc__"